import React from "react"
import { Link } from "gatsby"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "./footer.module.scss"

//TO DO: Replace Links in sitemap, sectors, contact and legal links with internal links in Contentful

const Footer = ({ data }) => {
  return (
    <footer
      className={
        "bg-edc-dark-blue text-sm w-full text-white px-6 py-10 lg:pb-0"
      }
    >
      <div
        className={`max-w-screen-2xl mx-auto border-b border-[#3d4c5e] mb-[44px] ${styles.newsletterWrapper}`}
      >
        <p className="md:text-[32px] text-[24px] leading-normal font-bold">
          {data.node.newsletterHeaderText}
        </p>
        <p className="md:text-base text-sm">{data.node.newsletterSubheader}</p>
        <div className={styles.newsLetterForm}>
          <RenderRichContent content={data.node.newsletterHubspotForm} />
        </div>
      </div>

      <div
        className={
          "flex flex-col justify-between max-w-screen-2xl mx-auto my-0 lg:flex lg:flex-row"
        }
      >
        <div className={"first-child:mb-2"}>
          <RenderRichContent
            content={data.node.footerSitemap}
            role={"footerlink"}
          />
        </div>
        <div>
          <RenderRichContent
            content={data.node.footerSectors}
            role={"footerlink"}
          />
        </div>
        <div>
          <RenderRichContent
            content={data.node.footerContact}
            role={"footerlink"}
          />
        </div>
        <div>
          <ul>
            <li
              className={
                "font-semibold text-white text-opacity-70 hover:text-opacity-100"
              }
            >
              <Link
                to={data.node.loginLink}
                data-gtm={data.node.trackLogin}
                target={"_blank"}
                rel="noreferrer"
              >
                {data.node.loginText}
              </Link>
            </li>
            <li
              className={
                "font-semibold text-white text-opacity-70 hover:text-opacity-100"
              }
            >
              <a
                href={data.node.supportLink}
                target={"_blank"}
                rel="noreferrer"
              >
                {data.node.supportText}
              </a>
            </li>
          </ul>
          <ul className={"flex flex-row w-fit justify-between"}>
            {data.node.footerSocialMedia.map((socialIcon, index) => {
              return (
                <li className={"w-10 h-10 mr-2"} key={index}>
                  <a
                    href={socialIcon.imageLink}
                    target={"_blank"}
                    rel="noreferrer nofollow"
                  >
                    <img
                      loading="lazy"
                      src={socialIcon.image.file.url}
                      alt={
                        socialIcon.image.file.description
                          ? socialIcon.image.file.description
                          : "social-media-icon"
                      }
                    />
                  </a>
                </li>
              )
            })}
          </ul>
          <ul className={"flex flex-row w-fit justify-between"}>
            <li className={"mr-6 w-[100px]"}>
              <a href={data.node.iso9001Pdf.file.url}>
                <img
                  loading="lazy"
                  src={data.node.footerIsoImages[0].file.url}
                  alt={
                    data.node.iso9001Pdf.file.description
                      ? data.node.iso9001Pdf.file.description
                      : "iso-9001"
                  }
                />
              </a>
            </li>
            <li className="w-[100px]">
              <a href={data.node.iso27001Pdf.file.url}>
                <img loading='lazy'                  
                src={data.node.footerIsoImages[1].file.url}
                  alt={
                    data.node.iso27001Pdf.file.description
                      ? data.node.iso27001Pdf.file.description
                      : "iso27001"
                  }
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        className={
          "flex flex-col justify-between lg:items-center max-w-screen-2xl mx-auto my-10 lg:flex lg:flex-row"
        }
      >
        <div className={"flex flex-column gap-[24px] flex-wrap lg:flex-row"}>
          {data.node.footerDownloadLinks.map((downloadlink, index) => {
            return (
              <a href={downloadlink.imageLink} key={index} target="_blank" rel="noreferrer nofollow">
                <img
                  loading="lazy"
                  src={downloadlink.image.file.url}
                  className={"h-12"}
                  alt={
                    downloadlink.image.description
                      ? downloadlink.image.description
                      : "download-link-image"
                  }
                />
              </a>
            )
          })}
        </div>
        <div>
          <a href="https://dutchview.com/" target="_blank" rel="noreferrer">
            <img
              loading="lazy"
              src={data.node.dutchviewLogo.file.url}
              alt={
                data.node.dutchviewLogo.description
                  ? data.node.dutchviewLogo.description
                  : "dutchview-logo"
              }
              className={"h-10 lg:mt-0 mt-[24px] "}
            />
          </a>
        </div>
      </div>
      <div
        className={
          "flex flex-col justify-between lg:items-center max-w-screen-2xl mx-auto mt-10 lg:flex lg:flex-row"
        }
      >
        <ul className={"lg:flex lg:flex-row lg:justify-between"}>
          <li className={"mr-10"}>
            &copy; Copyright {new Date().getFullYear()}{" "}
            <strong>Ed Controls</strong>
          </li>
          <RenderRichContent
            content={data.node.footerLegalLinks}
            role={"legal-link"}
          />
        </ul>
      </div>
    </footer>
  )
}

export default Footer
